// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__477W-","closeIcon":"styles_closeIcon__NrXRf","content":"styles_content__u1tRy","title":"styles_title__T2vtg","box":"styles_box__1BHVY"};